import ArticleLayout from "../components/ArticleLayout";

export default function PantsGuide() {
  return <ArticleLayout articleId={10} />;
}